module.exports = __webpack_public_path__ + "img/emptytypingtest.e211b039.svg";